var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 253.4 202.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d86c8",
    stroke: "#1c86c8",
    strokeMiterlimit: 10,
    d: "m123.69,51.26c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50Zm0,75.95c-14.33,0-25.95-11.62-25.95-25.95s11.62-25.95,25.95-25.95,25.95,11.62,25.95,25.95-11.62,25.95-25.95,25.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m187.54,51.26v24.05c14.33,0,25.95,11.62,25.95,25.95s-11.62,25.95-25.95,25.95v24.05c27.61,0,50-22.39,50-50s-22.39-50-50-50Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.69,101.26c0,27.61,22.39,50,50,50v-24.05c-14.33,0-25.95-11.62-25.95-25.95s11.62-25.95,25.95-25.95v-24.05c-27.61,0-50,22.39-50,50Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhat);
export default __webpack_public_path__ + "static/media/what.1c6c41b67d6799849c3e6311a2d49e2d.svg";
export { ForwardRef as ReactComponent };